/**
 * The following import is really important and is responsible to import all styles from the lib in the vite bundling
 */
import '@arsnovasystems/ars-front-lib/styles';
import * as Sentry from '@sentry/react';

import { initPromise } from '@/i18n/i18n.ts';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

void initPromise;

Sentry.init({
  dsn: 'https://36e37c86a92031a9ce4ec4891bdb2d53@o4510509785350144.ingest.de.sentry.io/4510703653290064',
  environment: import.meta.env.MODE,
  enabled: import.meta.env.ARS_IS_SENTRY_ENABLED === 'true',
  sendDefaultPii: true, // enable ip collection
  beforeSend(event) {
    const extra = event.extra;
    if (
      typeof extra?.__serialized__ === 'object' &&
      extra.__serialized__ !== null
    ) {
      const keys = Object.keys(extra.__serialized__);
      const hasAnyGwtSymptom = keys.some(
        (key) => key === '__gwt$backingJsError',
      );

      if (hasAnyGwtSymptom) {
        return null;
      }
    }

    return event;
  },
});

(() => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
})();
